var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 276 276"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 266,
    x: 5,
    y: 5,
    fill: "#E4884F",
    rx: 133
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 266,
    x: 5,
    y: 5,
    stroke: "#CE6827",
    strokeWidth: 10,
    rx: 133
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pending_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88 78.188C88 74.758 90.787 72 94.25 72h87.5c3.464 0 6.25 2.759 6.25 6.188s-2.786 6.187-6.25 6.187h-2.083v4.898a39 39 0 0 1-11.589 27.715L146.828 138l21.224 21.012a38.92 38.92 0 0 1 11.615 27.715v4.898h2.083c3.464 0 6.25 2.759 6.25 6.187S185.214 204 181.75 204h-87.5c-3.463 0-6.25-2.759-6.25-6.188s2.787-6.187 6.25-6.187h2.083v-4.898a39 39 0 0 1 11.589-27.715L129.172 138l-21.25-21.012a39 39 0 0 1-11.589-27.715v-4.898H94.25c-3.463 0-6.25-2.759-6.25-6.187m28.776 89.589A27 27 0 0 0 113.99 171h48.02a27 27 0 0 0-2.786-3.223L138 146.74l-21.224 21.012zM162.01 105a26.6 26.6 0 0 0 5.157-15.727v-4.898h-58.334v4.898A26.53 26.53 0 0 0 113.99 105z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pending_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88 72h100v132H88z"
  })))));
};
export default SvgPending;